import { Divider, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { getDecks, updateHeaderInfo, copyDeck, getUserDetails, getFlashCards, getThisFlashCard } from "../actions";
import { FlashCard, CopyrightWidget, LoadingCard } from "../components";
import { deviceData, setContainer, scrollTop, getThisYear, setColorObj } from "../common";
import { isBrowser } from 'react-device-detect';

class FlashCardReviewScreen extends Component {
    state = {
        reload: false,
        copyModal: false,
        text: 'test...',
        deckid: 0,
        year: 0,
        questionid: 0,
        loading: 1,
        fc: {}
    }

    componentDidMount = async () => {
        const { mcid, key } = this.props.auth_feedback;

        await this.props.getThisFlashCard({ 
            mcid: mcid, 
            key: key,
            deckid: this.props.location.deckid,
            year: this.props.location.year
        });

        await this.setState({ 
            ...this.state, 
            deckid: this.props.location.deckid,
            year: this.props.location.year
        });

        return this.props.updateHeaderInfo({
            route:"/FlashCardScreen", 
            name: "Flashcards", 
            iconTwo: 'menu',
            iconOne: 'home',
        });
    };

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.flashCard !== this.props.flashCard) {
            scrollTop('FlashCardReviewScreenDiv');

            return this.setState({ 
                ...this.state, 
                fc: this.props.flashCard, 
                // loading: 0, 
                questionid: this.props.flashCard.questionID 
            });
        }

        if (this.state.fc !== prevState.fc) {
            return this.setState({
                ...this.state,
                loading: 0
            })
        }
    }

    handleOpen = () => {
        this.setState({
            ...this.state,
            copyModal: true,
        });
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            copyModal: false,
        });
    };

    nextFunc = async () => {
        let obj = {
            deckid: this.state.deckid,
            year: this.state.year,
            questionid: this.state.questionid,
            mcid: this.props.user_details.mcid,
            key: this.props.auth_feedback.key
        };

        await this.setState({ ...this.state, loading: 1 });
        return this.props.getThisFlashCard(obj);
    }

    backFunc = () => {
        this.props.history.goBack();
    }

    render() {
        let colorObj = setColorObj('base');
        if (this.state.loading === 0) {
            return (
                <>
                    <div style={setContainer(isBrowser)} className=" aua-overflow" id="FlashCardReviewScreenDiv">
                        <Typography className="homeDividerText flashcardHeaders">Flashcards</Typography>                            

                        <FlashCard
                            deckColor={colorObj.deck}
                            textColor={colorObj.text}
                            buttonColor={colorObj.button}
                            nextFunc={this.nextFunc}
                            backFunc={this.backFunc}
                            deckid={Number(this.state.deckid)}
                            year={Number(this.state.year)}
                            questionid={this.state.questionid}
                            obj={this.state.fc}
                        />

                        <CopyrightWidget 
                            year={getThisYear()}
                            textAlign={'center'}
                            className="margin-top-8 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                        />
                    </div>
                </>
            );
        } else {
            return (
                <LoadingCard text="Loading..."/>
            )
        }
            
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { flashCards } = state.decks;
    const { flashCard } = state.question;
    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        flashCards,
        auth_feedback,
        user_details,
        flashCard
    };
};

export default connect(mapStateToProps, 
    { 
        updateHeaderInfo, getDecks, copyDeck, getUserDetails, getFlashCards, getThisFlashCard
    })(withRouter(FlashCardReviewScreen));